<template>
  <div class="ecosystem-info-card">
    <div v-if="title" class="title">
      <span
        class="label-indicator"
        v-if="labelColor"
        :style="{ backgroundColor: labelColor }">
      </span>
      {{title}}
    </div>
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    labelColor: String,
    title: String
  }
}
</script>

<style lang="scss" scoped>
.ecosystem-info-card {
  background-color: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  padding: 16px;
  align-items: center;
}

.title {
  align-items: center;
  color: #6b7280;
  display: flex;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.04em;
}

.label-indicator {
  border-radius: 9999px;
  height: 8px;
  margin-right: 8px;
  width: 8px;
}

.text-lg {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.text-muted {
  color: #9ca3af;
}
</style>
